import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  transform(seconds: number): string {
    const hhmmss = new Date(seconds * 1000).toISOString().substr(11, 8);
    if (hhmmss.indexOf('00:0') === 0) {
      return hhmmss.substring(4);
    } else if (hhmmss.indexOf('00') === 0) {
      return hhmmss.substring(3);
    } else if (hhmmss.indexOf('0') === 0) {
      return hhmmss.substring(1);
    } else {
      return hhmmss;
    }
  }
}
